import { render, staticRenderFns } from "./Institutes.vue?vue&type=template&id=a47f9500&scoped=true"
import script from "./Institutes.vue?vue&type=script&lang=js"
export * from "./Institutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47f9500",
  null
  
)

export default component.exports